// import '../components/_ajax-anim'
import init from "../components/_accordions";

let filterItems = document.querySelectorAll('[js-anim-label-filter]');
let activeClass = 'is-active'

init();

filterItems.forEach((el)=> {
    el.addEventListener('click', ()=> {

        if (!el.parentNode.classList.contains(activeClass)) {
            filterItems.forEach((el2)=> {
                if (el2.parentNode.classList.contains(activeClass)) {
                    el2.parentNode.classList.remove(activeClass)
                }
            })

            el.parentNode.classList.add(activeClass);
        }
    })
})